import React from 'react'
import TopHeader from './TopHeader'
import MiddleHeader from './MiddleHeader'
import BottomHeader from './BottomHeader'
import clsx from 'clsx'

const Header: React.FC = () => {
  return (
    <div className={clsx('fixed top-0 left-0 w-full z-50 shadow-xl bg-white')}>
      <TopHeader />
      <MiddleHeader />
      <BottomHeader />
    </div>
  )
}

export default Header
